import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import TermsAndConditionsComponent from "../../termsandcondition/TermsAndConditionsComponent";

export const TermsAndConditionsModal = ({ openModal, onClose }) => {
  return (
    <Dialog open={openModal} onClose={onClose}>
      <DialogTitle>Términos y condiciones RECEPAM.</DialogTitle>
      <DialogContent>
        <TermsAndConditionsComponent/>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};
